import script from "./DarkModeToggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./DarkModeToggle.vue?vue&type=script&lang=ts&setup=true"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=6029786c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6029786c"]])

export default __exports__